import {
  Box,
  CircularProgress,
  Fade,
  makeStyles,
  Theme,
  useTheme,
} from '@material-ui/core';
import Button, {ButtonProps} from '@material-ui/core/Button';
import React, {FunctionComponent, useMemo} from 'react';

export interface ButtonWithProgressProps extends ButtonProps {
  isFetching?: boolean;
}
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: 'relative',
  },
  wrapper: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
}));

const ButtonWithProgress: FunctionComponent<ButtonWithProgressProps> = ({
  isFetching = false,
  disabled,
  children,
  ...rest
}: ButtonWithProgressProps) => {
  const classes = useStyles();
  const theme = useTheme();

  const isDisabled = disabled || isFetching;

  const fadeStyle = useMemo(
    () => ({
      transitionDelay: isFetching ? '800ms' : '0s',
    }),
    [isFetching]
  );

  return (
    <Button className={classes.root} disabled={isDisabled} {...rest}>
      <Fade in={isFetching} style={fadeStyle}>
        <Box
          className={classes.wrapper}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={theme.spacing(3)} />
        </Box>
      </Fade>
      {children}
    </Button>
  );
};

export default ButtonWithProgress;
